import { render, staticRenderFns } from "./HeaderMainLogo.vue?vue&type=template&id=2588a804&"
import script from "./HeaderMainLogo.vue?vue&type=script&lang=js&"
export * from "./HeaderMainLogo.vue?vue&type=script&lang=js&"
import style0 from "./HeaderMainLogo.vue?vue&type=style&index=0&id=2588a804&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports